import React, { useState, useEffect } from "react";
import { useLocation } from "react-router-dom";
import axios from "axios";

const InvestmentPage = ({ dateFromReport }) => {
  console.log("Date from report prop:", dateFromReport);
  const [balance, setBalance] = useState([]);
  const [filteredData, setFilteredData] = useState([]);
  const location = useLocation();
  const [loanDetails, setLoanDetails] = useState([]);
  const [dailyTotal, setDailyTotal] = useState(0);
  const [weeklyTotal, setWeeklyTotal] = useState(0);
  const [collectionAmount, setCollectionAmount] = useState([]);
  const [loading, setLoading] = useState(true);
  const [collections, setCollections] = useState([]);
  const [newLoans, setNewLoans] = useState([]);
  const baseURL = process.env.REACT_APP_BASE_URL;

  const formatDate = (date) => {
    if (!date) return null;

    const [year, month, day] = date.split("-");

    if (!day || !month || !year) return null;

    return `${day}/${month}/${year}`;
  };

  const formatDateForData = (dateStr) => {
    const [day, month, year] = dateStr.split("-");
    return `${year}-${month}-${day}`;
  };

  useEffect(() => {
    const formattedDate = dateFromReport;

    if (loanDetails && loanDetails.length > 0) {
      const filtered = loanDetails.filter((loan) => {
        const loanDate = loan.log_date;
        return (
          loan.scheme_name?.toLowerCase() === "daily collection" &&
          loanDate === formattedDate
        );
      });

      const filteredWeekly = loanDetails.filter((loan) => {
        const loanDate = loan.log_date;
        return (
          loan.scheme_name?.toLowerCase() === "weekly collection" &&
          loanDate === formattedDate
        );
      });

      const totalEmiDailyAmount = filtered.reduce((total, loan) => {
        return total + parseFloat(loan.log_amount.trim());
      }, 0);

      const totalEmiWeeklyAmount = filteredWeekly.reduce((total, loan) => {
        return total + parseFloat(loan.log_amount.trim());
      }, 0);

      setDailyTotal(totalEmiDailyAmount);
      setWeeklyTotal(totalEmiWeeklyAmount);
    }
  }, [loanDetails, dateFromReport]);

  useEffect(() => {
    const currentDate = dateFromReport;

    if (collections && collections.length > 0) {
      const filtered = collections.filter((loan) => {
        const loanDate = loan.start_date;
        return (
          (loan.scheme_name?.toLowerCase() === "daily collection" ||
            loan.scheme_name?.toLowerCase() === "weekly collection") &&
          loanDate === currentDate
        );
      });
      setNewLoans(filtered);
    }
  }, [collections, dateFromReport]);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const accessToken = sessionStorage.getItem("access_token");
        const response = await axios.get(`${baseURL}/fetchOpeningBalance`, {
          headers: {
            Authorization: `Bearer ${accessToken}`,
          },
        });
        setBalance(response.data);
        const responses = await axios.get(`${baseURL}/fetchBalance`, {
          headers: {
            Authorization: `Bearer ${accessToken}`,
          },
        });
        const data = responses.data;
        const resp = await axios.get(`${baseURL}/getAllLoan`, {
          headers: {
            Authorization: `Bearer ${accessToken}`,
          },
        });
        const collections = resp.data;

        setCollections(collections);
        setLoanDetails(data.loan_details);
      } catch (error) {
        console.error("Error fetching data:", error);
      } finally {
        setLoading(false);
      }
    };
    fetchData();
  }, []);

  useEffect(() => {
    const reportDate = formatDateForData(dateFromReport);
    if (balance.length > 0) {
      const filtered = balance.filter((item) => item.date1 == dateFromReport);
      setFilteredData(filtered);
    }
  }, [balance, dateFromReport]);

  const openingAmount =
    filteredData.length > 0 ? filteredData[0].opening_amount : 0;
  const totalCollection =
    filteredData.length > 0 ? filteredData[0].collection_amount : 0;
  const loanAmount =
    filteredData.length > 0 ? filteredData[0].new_loan_amount : 0;
  const closingAmount =
    filteredData.length > 0 ? filteredData[0].closing_amount : 0;
  const openingProfit =
    filteredData.length > 0 ? filteredData[0].opening_profit : 0;
  const profit = filteredData.length > 0 ? filteredData[0].profit : 0;
  const closingProfit =
    filteredData.length > 0 ? filteredData[0].closing_profit : 0;

  if (loading) {
    return (
      <div className="flex justify-center items-center h-64">
        <p className="text-lg font-semibold text-gray-600">Loading…</p>
      </div>
    );
  }
  return (
    <div id="printable-content" className="container mx-auto p-4">
      <h2 className="text-center text-2xl font-bold mb-4">
        Date: {formatDate(dateFromReport)}
      </h2>
      <div className="flex flex-col lg:flex-row lg:justify-between space-y-4 lg:space-y-0 lg:space-x-4">
        {/* Investment Table */}
        <div className="w-full lg:w-1/2 border p-2">
          <h3 className="font-bold text-center text-lg mb-2">Investment</h3>
          <table className="w-full border-collapse">
            <tbody>
              {/* Opening Balance row */}
              <tr className="bg-gray-100">
                <td className="border p-2 text-left font-bold">
                  Opening Balance
                </td>
                <td className="border p-2 text-left">{openingAmount}</td>
              </tr>

              {/* Daily Total row */}
              <tr className="bg-white">
                <td className="border p-2 text-right font-bold">Daily</td>
                <td className="border p-2 text-left">{dailyTotal}</td>
              </tr>

              {/* Weekly Total row */}
              <tr className="bg-gray-100">
                <td className="border p-2 text-right font-bold">Weekly</td>
                <td className="border p-2 text-left">{weeklyTotal}</td>
              </tr>

              {/* Collection Amount row */}
              <tr className="bg-white">
                <td className="border p-2 text-left font-bold">
                  Collection Amount (+)
                </td>
                <td className="border p-2 text-left">{totalCollection}</td>
              </tr>

              {/* New Loans rows */}
              {newLoans &&
                newLoans.length > 0 &&
                newLoans.map((item, index) => (
                  <tr
                    key={index}
                    className={index % 2 === 0 ? "bg-white" : "bg-gray-100"}
                  >
                    <td className="border p-2 text-right">{item.tamilname}</td>
                    <td className="border p-2 text-left">{item.amount}</td>
                  </tr>
                ))}

              {/* New Loan Amount row */}
              <tr className="bg-white">
                <td className="border p-2 text-left font-bold">
                  New Loan Amount (-)
                </td>
                <td className="border p-2 text-left">{loanAmount}</td>
              </tr>

              {/* Closing Balance row */}
              <tr className="bg-gray-100">
                <td className="border p-2 text-left font-bold">
                  Closing Balance
                </td>
                <td className="border p-2 text-left">{closingAmount}</td>
              </tr>
            </tbody>
          </table>
        </div>

        {/* Profit Table */}
        <div className="w-full lg:w-1/2 border p-2">
          <h3 className="font-bold text-center text-lg mb-2">Profit</h3>
          <table className="w-full border-collapse">
            <tbody>
              {/* Opening Profit row */}
              <tr className="bg-gray-100">
                <td className="border p-2 text-left font-bold">
                  Opening profit
                </td>
                <td className="border p-2 text-left">{openingProfit}</td>
              </tr>

              {/* New Loans Profit rows */}
              {newLoans &&
                newLoans.length > 0 &&
                newLoans.map((item, index) => (
                  <tr
                    key={index}
                    className={index % 2 === 0 ? "bg-white" : "bg-gray-100"}
                  >
                    <td className="border p-2 text-right">{item.tamilname}</td>
                    <td className="border p-2 text-left">
                      {item.initial_profit}
                    </td>
                  </tr>
                ))}

              {/* Profit row */}
              <tr className="bg-white">
                <td className="border p-2 text-left font-bold">Profit</td>
                <td className="border p-2 text-left">{profit}</td>
              </tr>

              {/* Closing Profit row */}
              <tr className="bg-gray-100">
                <td className="border p-2 text-left font-bold">
                  Closing Profit
                </td>
                <td className="border p-2 text-left">{closingProfit}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
};

export default InvestmentPage;
